import { render, staticRenderFns } from "./CustomDiagram.vue?vue&type=template&id=02631c18&scoped=true&"
import script from "./CustomDiagram.vue?vue&type=script&lang=ts&"
export * from "./CustomDiagram.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDiagram.vue?vue&type=style&index=0&id=02631c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02631c18",
  null
  
)

export default component.exports